import { FormattedMessage } from 'react-intl'
import MenuButton from '@components/MenuButton/MenuButton'

import icon from '@static/vectors/icon-datalab.svg'
import './ResponsiveShield.css'

export default function ResponsiveShield() {
  return (
    <div id="responsive-shield">
      <MenuButton />
      <section id="responsive-shield-wrapper">
        <div className="container">
          <img src={icon} alt="dataLab icon" />
          <h1>
            <span>
              <FormattedMessage id="responsive-shield.title" />
            </span>
          </h1>
          <p>
            <FormattedMessage id="responsive-shield.text" />
          </p>
        </div>
      </section>
    </div>
  )
}
